import { GridItem } from '@tvg/fuse-design/responsive-grid';
import React from 'react';
import styled from 'styled-components';

export interface BannerContainerProps {
  itemKey: number;
}

const StyledGridItem = styled(GridItem)`
  & {
    display: grid;
    grid-column: auto / span 12;
    width: 100%;
  }

  &.grid-item--hidden {
    display: none;
  }
`;

function BannerContainer({ itemKey }: BannerContainerProps) {
  return (
    <StyledGridItem
      data-testid="gallery-banner-container"
      id={`recs-banner${itemKey}`}
      className="grid-item grid-item--recs-banner grid-item--content-banner grid-item--hidden"
      data-content-in-grid-banner
    />
  );
}

export default React.memo(BannerContainer);
